import promise from 'bluebird';
import {trustScoreService} from "../_services";
import {ResponseFilter} from "../config/response-handler";

export const trustScoreActions = {
    getTrustScore,
    saveTrustScore,
    updateTrustScore,
};

export const trustScoreConstants = {
    GET_TRUST_SCORE_REQUEST: "GET_TRUST_SCORE_REQUEST",
    GET_TRUST_SCORE_SUCCESS: "GET_TRUST_SCORE_SUCCESS",
    GET_TRUST_SCORE_ERROR: "GET_TRUST_SCORE_ERROR",
    SAVE_TRUST_SCORE_REQUEST: "SAVE_TRUST_SCORE_REQUEST",
    SAVE_TRUST_SCORE_SUCCESS: "SAVE_TRUST_SCORE_SUCCESS",
    SAVE_TRUST_SCORE_ERROR: "SAVE_TRUST_SCORE_ERROR",
    UPDATE_TRUST_SCORE_REQUEST: "UPDATE_TRUST_SCORE_REQUEST",
    UPDATE_TRUST_SCORE_SUCCESS: "UPDATE_TRUST_SCORE_SUCCESS",
    UPDATE_TRUST_SCORE_ERROR: "UPDATE_TRUST_SCORE_ERROR",
};

function getTrustScore(params) {
    return function (dispatch) {
        return new promise(function (resolve, reject) {
            dispatch(request(params));
            trustScoreService.getTrustScore(params)
                .then(response => {
                    let {serverResponseData} = ResponseFilter(response);
                    resolve(serverResponseData);
                    dispatch(success(serverResponseData));
                })
                .catch((err) => {
                    reject(err);
                    dispatch(failure(err));
                });
        });
    };

    function request(getTrustScoreRequest) {
        return {type: trustScoreConstants.GET_TRUST_SCORE_REQUEST, getTrustScoreRequest};
    }
    function success(getTrustScoreSuccess) {
        return {type: trustScoreConstants.GET_TRUST_SCORE_SUCCESS, getTrustScoreSuccess};
    }
    function failure(getTrustScoreFail) {
        return {type: trustScoreConstants.GET_TRUST_SCORE_ERROR, getTrustScoreFail};
    }
}

function saveTrustScore(params) {
    return function (dispatch) {
        return new promise(function (resolve, reject) {
            dispatch(request(params));
            trustScoreService.saveTrustScore(params)
                .then(response => {
                    let {serverResponseData} = ResponseFilter(response);
                    resolve(serverResponseData);
                    dispatch(success(serverResponseData));
                })
                .catch((err) => {
                    reject(err);
                    dispatch(failure(err));
                });
        });
    };

    function request(saveTrustScoreRequest) {
        return {type: trustScoreConstants.SAVE_TRUST_SCORE_REQUEST, saveTrustScoreRequest};
    }
    function success(saveTrustScoreSuccess) {
        return {type: trustScoreConstants.SAVE_TRUST_SCORE_SUCCESS, saveTrustScoreSuccess};
    }
    function failure(saveTrustScoreFail) {
        return {type: trustScoreConstants.SAVE_TRUST_SCORE_ERROR, saveTrustScoreFail};
    }
}

function updateTrustScore(params) {
    return function (dispatch) {
        return new promise(function (resolve, reject) {
            dispatch(request(params));
            trustScoreService.updateTrustScore(params)
                .then(response => {
                    let {serverResponseData} = ResponseFilter(response);
                    resolve(serverResponseData);
                    dispatch(success(serverResponseData));
                })
                .catch((err) => {
                    reject(err);
                    dispatch(failure(err));
                });
        });
    };

    function request(updateTrustScoreRequest) {
        return {type: trustScoreConstants.UPDATE_TRUST_SCORE_REQUEST, updateTrustScoreRequest};
    }
    function success(updateTrustScoreSuccess) {
        return {type: trustScoreConstants.UPDATE_TRUST_SCORE_SUCCESS, updateTrustScoreSuccess};
    }
    function failure(updateTrustScoreFail) {
        return {type: trustScoreConstants.UPDATE_TRUST_SCORE_ERROR, updateTrustScoreFail};
    }
}
